// /* eslint-disable no-console */
import React from 'react';
import {connect} from 'react-redux';
import PaymentRequest from '../../models/payer/PaymentRequest';
import DepositRequest from '../../models/payer/DepositRequest';
import {toast} from 'react-toastify';
import {Route} from 'react-router-dom';
import {
  getAllPaymentOptions,
  getBeforeCreditTotal,
  getCreditTotal,
  getCustomerNumber, getInvoiceQuery,
  getInvoiceTotal,
  getOverpayingAmount,
  getPayTotal,
  getSelectedPaymentOption, getSelectedPrimaryAccount
} from './Selectors'
import {
  updateCVV,
  updateSelectedCard,
  makePayment,
  mapCards,
  makeDeposit, getInvoices,
} from '../../actions/InvoiceActions';
import * as validationTypes from '../../constants/ValidationConstants';
import {
  createPayerData,
  mapInvoiceListToPaymentDocuments,
  mapPaymentDetails,
  valueEquals,
  mapDepositDetails
} from "./PaymentFunctions";
import ManagePaymentMethods from "../payment-methods/manage-payment-methods/ManagePaymentMethods";
import {formatMoney} from '../../common/invoiceHelpers';
import {canMakePayment, canManagePaymentMethods} from "../../PermissionSelectors";
import {InvoicesContext} from "./InvoiceDataManager";
import {faChevronDown, faExclamationCircle} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

class Payment extends React.Component {
  static contextType = InvoicesContext;
  constructor(props) {
    super(props);
    this.state = {
      disablePay: false,
      showManagePayments: false,
      cvvValidationMessage: '',
      cvvValue: '',
    };
    if (props.impersonatedUserId === null && !props.canMakePayment) {
      this.state.disablePay = true;
    }
    this.handlePaymentCardChange = this.handlePaymentCardChange.bind(this);
    this.onPayClick = this.onPayClick.bind(this);
    this.onCVVChange = this.onCVVChange.bind(this);
    this.showManagePayments = this.showManagePayments.bind(this);
    this.hideManagePayments = this.hideManagePayments.bind(this);
    this.onDepositClick = this.onDepositClick.bind(this);
  }

  onCVVChange = (e) => {
    this.setState({
      cvvValue: e.target.value,
    });
    if (!e.target.value) {
      this.setState({cvvValidationMessage: validationTypes.CVV_EMPTY});
    } else {
      this.validateCvv(e.target.value);
    }
  };

  validateCvv(cvv) {
    if (cvv.length < 3 || cvv.length > 4) {
      this.setState({cvvValidationMessage: validationTypes.CVV_INVALID});
      return false;
    } else if (cvv.length >= 3 && cvv.length <= 4) {
      this.setState({cvvValidationMessage: ''});
      return true;
    }
  }

  showManagePayments() {
    this.setState({...this.state, showManagePayments: true});
  }

  hideManagePayments() {
    this.setState({...this.state, showManagePayments: false});
  }

  onPayClick = (event, history) => {
    toast.dismiss();
    if (this.props.selectedPaymentOption === null) {
      toast.warn(validationTypes.CARD_NOT_SELECTED, {position: toast.POSITION.TOP_RIGHT});
      event.preventDefault();
      return false;
    }

    if (!this.props.isInvoiceOverpaymentAllowed && this.props.overPayingAmount > 0) {
      toast.warn(validationTypes.OVER_PAY_NOT_ALLOWED, {position: toast.POSITION.TOP_RIGHT});
      event.preventDefault();
      return false;
    }
    if (this.cvvRequired() && this.props.selectedPaymentOption.payment_card_type !== 'EC') {
      if (this.state.cvvValue === "") {
        toast.warn(validationTypes.CVV_EMPTY, {position: toast.POSITION.TOP_RIGHT});
        event.preventDefault();
        return false;
      } else if (!this.validateCvv(this.state.cvvValue)) {
        toast.warn(validationTypes.CVV_INVALID, {position: toast.POSITION.TOP_RIGHT});
        event.preventDefault();
        return false;
      }
    }
    // if credit present, to check if total is greater than 0, 
    // adding credit to total instead of deducting it.
    if (this.props.creditTotal < 0 && (this.props.beforeCreditTotal + this.props.creditTotal) <= 0) {
      toast.warn(
        validationTypes.CREDIT_AMOUNT_VALIDATION_ERRORS,
        {position: toast.POSITION.TOP_RIGHT},
      );
      event.preventDefault();
      return false;
    }

    if (this.props.payTotal <= 0) {
      toast.warn(
        validationTypes.PAY_AMOUNT_VALIDATION_MESSAGE,
        {position: toast.POSITION.TOP_RIGHT},
      );
      event.preventDefault();
      return false;
    }

    // Check for reason codes
    let keys = Object.keys(this.props.invoiceDetails);
    if (this.props.reasonNotRequired !== 'X') {
      for (let i = 0; i < keys.length; i++) {
        let details = this.props.invoiceDetails[keys[i]];
        let invoice = this.props.invoices[keys[i]];

        // Skip if credit 
        if (invoice.total_amount >= 0) {
          let reasonMissing = (details.reason === "" || details.reason === null);
          let reasonRequired = details.amount < invoice.open_amount && reasonMissing;
          if (reasonRequired) {
            toast.warn(validationTypes.REASON_REQUIRED, {position: toast.POSITION.TOP_RIGHT});
            return;
          }
          if (!reasonMissing) {
            for (let j = 0; j < this.props.reason_codes.length; j++) {
              if (details.reason === this.props.reason_codes[j].reason_code) {
                if (valueEquals(this.props.reason_codes[j].comments_required, "X")) {
                  if (details.comment === "") {
                    toast.warn(validationTypes.REASON_DESCRIPTION_VALIDATION_MESSAGE, {position: toast.POSITION.TOP_RIGHT});
                    return;
                  }
                }
              }
            }
          }
        }
      }
    }

    let invoices = mapInvoiceListToPaymentDocuments(this.props.invoices, this.props.invoiceDetails, this.props.reason_codes);
    let paymentDetails = mapPaymentDetails(this.props.selectedPaymentOption, this.state.cvvValue, this.props.payerDetails.address_data);
    let payerData = createPayerData(this.props.customerNumber, this.props.selectedPrimaryAccount.CompanyCode);
    let paymentRequest = new PaymentRequest(payerData, paymentDetails, invoices);

    this.setState({disablePay: true});

    return makePayment(this.props.dispatch, paymentRequest, () => history.push('/invoices/payment-status')).then((success) => {
      if(success){
        getInvoices(this.props.dispatch, this.props.invoiceSearchQuery);//.then(invoices => setInvoices(invoices));
      }
      this.setState({disablePay: false});
    });
  };

  onDepositClick = (event, history) => {
    if (!this.props.form.isValid) {
      this.props.form.handleSubmit();
      event.preventDefault();
      return false;
    }
    if (this.props.selectedPaymentOption === null) {
      toast.warn(validationTypes.CARD_NOT_SELECTED, {position: toast.POSITION.TOP_RIGHT});
      event.preventDefault();
      return false;
    }
    if (this.cvvRequired() && this.state.cvvValue === "" && this.props.selectedPaymentOption.payment_card_type !== 'EC') {
      toast.warn(validationTypes.CVV_EMPTY, {position: toast.POSITION.TOP_RIGHT});
      event.preventDefault();
      return false;
    }

    let paymentDetails = mapPaymentDetails(this.props.selectedPaymentOption, this.state.cvvValue, this.props.payerDetails.address_data);
    let payerData = createPayerData(this.props.customerNumber, this.props.selectedPrimaryAccount.CompanyCode);
    let depositDetail = mapDepositDetails(this.props.form.values)
    let depositRequest = new DepositRequest(payerData, paymentDetails, depositDetail);

    this.setState({disablePay: true});

    return makeDeposit(this.props.dispatch, depositRequest).then(() => {
      this.setState({disablePay: false});
      history.push('/invoices/payment-status');
    });
  }

  handlePaymentCardChange = (selectedCard) => {
    if (selectedCard.target.value) {
      updateSelectedCard(this.props.dispatch, selectedCard.target.value);
    } else {
      updateSelectedCard(this.props.dispatch, "");
    }
    updateCVV(this.props.dispatch, "");
    this.setState({cvvValue: ""});
  };

  cvvRequired() {
    return this.props.cvvRequired && this.props.selectedPaymentOption && this.props.selectedPaymentOption.payment_card_type !== 'EC';
  }

  getDepositAmount(values) {
    const amountToProcess = values && values.amount_to_process ? values.amount_to_process : '';
    return amountToProcess;
  }


  render() {
    const paymentCardOptions = mapCards(this.props.allPaymentOptions);
    const depositAmount = this.props && this.props.mode && this.props.mode === 'deposit' ? this.getDepositAmount(this.props.form.values) : '';
    const isDepositMode = this.props && this.props.mode && this.props.mode === 'deposit' ? true : false;
    return (
      <div>
        <h2 className="invoicesHeading">Payment</h2>
        <div className="card">
          <div className="card-body">
            <div className="row">
              <div className="col-lg-3 text-secondary">
                <div className="row no-gutters">
                  <div className="col-6 mb-3 d-flex align-items-center">
                    {this.props.mode ? 'Deposit Total' : 'Invoice Total'}
                  </div>
                  <div className="col-6 mb-3 payment-totals">
                    {`$ ${depositAmount ? formatMoney(depositAmount) : formatMoney(this.props.invoiceTotal)}`}
                  </div>
                </div>
              </div>
              <div className="col-lg-3 text-secondary">
                <div className="row no-gutters">
                  <div className="col-3 mb-3 d-flex align-items-center">
                    Pay
                  </div>
                  <div className="col-9 mb-3 payment-totals">
                    {`$ ${depositAmount ? formatMoney(depositAmount) : formatMoney(this.props.payTotal)}`}
                  </div>
                </div>
              </div>
              {this.props.overPayingAmount > 0 &&
              <React.Fragment>
                <div className="col-lg-3 text-secondary">
                  <div className="row no-gutters">
                    <div className="col-6 mb-3 d-flex align-items-end">
                      Overpaying
                    </div>
                    <div className="col-6 mb-3 payment-totals">
                        <span
                          className="overpaying_Amount_color"> {`$ ${formatMoney(this.props.overPayingAmount)}`} </span>
                    </div>
                  </div>
                </div>
                {this.props.isInvoiceOverpaymentAllowed && <div className="col-lg-3 text-secondary">
                  <div className="d-flex mb-3">
                    <div className="d-flex align-items-center">
                      <FontAwesomeIcon icon={faExclamationCircle} size={"lg"} className={"circle_Exclamation_Color"}/>
                    </div>
                    <div className="overpaying-text d-flex align-items-center">
                      <div>
                        {`$ ${formatMoney(this.props.overPayingAmount)}`} will be applied as an additional deposit to
                        your account
                      </div>
                    </div>
                  </div>
                </div>
                }
              </React.Fragment>
              }
            </div>
            <div className="row">
              <div className="col-lg-6 col-md-12 col-sm-12">
                <div className="row no-gutters">
                  <div
                    className="col-lg-4 col-md-6 col-sm-6 col-form-label col-form-label-sm text-secondary mb-3"> Payment
                    Method
                  </div>
                  <div className="col-lg-8 col-md-6 col-sm-6 text-center mb-3 paymentCustomSelect">
                    <select
                      name="paymentStatus"
                      placeholder="Pay with"
                      className="form-control"
                      value={this.props.selectedCardIndex}
                      onChange={this.handlePaymentCardChange}>
                      <option value="" disabled selected="selected">Pay With</option>
                      {paymentCardOptions.map(option => {
                        return (
                          <option value={option.index} key={option.index}>
                            {option.label}
                          </option>
                        )
                      })}
                    </select>
                    <FontAwesomeIcon icon={faChevronDown} className={"select-arrow"}/>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-6"/>
                  <div className="col-lg-8 col-md-6 col-sm-6 text-center">
                    {!this.state.showManagePayments &&
                    <div className={"manage-payment-button"} onClick={this.showManagePayments}>Manage Payment
                      Methods</div>}
                    {this.state.showManagePayments &&
                    <div className={"manage-payment-button"} onClick={this.hideManagePayments}>Hide Payment
                      Methods</div>}
                  </div>
                </div>
              </div>
              <div className="text-left col-lg-2 col-md-8 col-sm-6 col-7">
                {this.cvvRequired() &&
                <input
                  key="txtCvv"
                  type="text"
                  className={`col form-control text-left ${this.state.cvvValidationMessage ? 'invalid' : ''}`}
                  placeholder="CVV"
                  onChange={this.onCVVChange}
                  value={this.state.cvvValue}
                />
                }
                {
                  (this.cvvRequired()) && <h6 className="invalid-Text">
                    <small>{this.state.cvvValidationMessage}</small>
                  </h6>
                }
              </div>
              <div className="col-lg-3 col-md-12 col-sm-12 d-none d-lg-block">
                <Route render={({history}) => (
                  <button
                    type="button"
                    id="btnPay"
                    className="btn btn-primary buttonColor fixed-left form-control test"
                    disabled={this.state.disablePay}
                    onClick={(e) => {
                      !isDepositMode ? this.onPayClick(e, history) : this.onDepositClick(e, history)
                    }}
                  >
                    Pay
                  </button>
                )}/>
              </div>
            </div>
            <div className={"row mb-2"}>
                        <div className={"col-md-12"}>
                            {this.state.showManagePayments && <div className="manage-payment-section" style={{ display: "flex", flexDirection: "column" }}>
                  <ManagePaymentMethods alwaysSaveOnFile={false}/>
                </div>
                }
              </div>
            </div>
            <div className="row">
              <div className="col d-lg-none">
                <Route render={({history}) => (
                  <button
                    type="button"
                    id="btnPay"
                    className="btn btn-primary buttonColor fixed-left form-control form-control-sm"
                    disabled={this.state.disablePay}
                    onClick={(e) => {
                      !isDepositMode ? this.onPayClick(e, history) : this.onDepositClick(e, history)
                    }}
                  >
                    Pay
                  </button>
                )}/>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Payment.propTypes = {};

export default connect((store, props) => ({
  cvvRequired: store.default.cvvRequired,
  isInvoiceOverpaymentAllowed: store.app.isInvoiceOverpaymentAllowed,
  isPartialPaymentsAllowed: store.app.isPartialPaymentsAllowed,
  totalAmountWithCredit: store.default.totalAmountWithCredit,
  payerDetails: store.default.payerDetails,
  selectedSecondaryAccount: store.user_options.selectedSecondaryAccount,
  selectedPrimaryAccount: getSelectedPrimaryAccount(store, props),
  currentUser: store.default.currentUser,
  reasonNotRequired: store.default.reasonNotRequired,
  overPayNote: store.default.overPayNote,
  payTotal: getPayTotal(store, props),
  invoiceTotal: getInvoiceTotal(store, props),
  creditTotal: getCreditTotal(store, props),
  beforeCreditTotal: getBeforeCreditTotal(store, props),
  overPayingAmount: getOverpayingAmount(store, props),
  selectedPaymentOption: getSelectedPaymentOption(store, props),
  selectedCardIndex: store.default.selectedCard,
  customerNumber: getCustomerNumber(store, props),
  invoices: store.invoice.selected,
  invoiceDetails: store.invoice.invoiceDetail,
  reason_codes: store.app.cnbsConfig.payment_reason_codes,
  allPaymentOptions: getAllPaymentOptions(store, props),
  impersonatedUserId: store.user_options.impersonatedUserId,
  canManagePaymentMethods: canManagePaymentMethods(store, props),
  canMakePayment: canMakePayment(store, props),
  invoiceSearchQuery: getInvoiceQuery(store, props),
}))(Payment);
